import christy from './christy.jpg';
import michael from './michael.jpg';
import taryn from './taryn.jpg';
import tracy from './tracy.jpg';

export default {
  christy,
  michael,
  taryn,
  tracy
}
